import { Input } from '@conteg/ui';
import { useTranslation } from 'react-i18next';

export interface CourierCompany {
  id: string;
  name: string;
}

interface CourierInputProps {
  personalId: string;
  onPersonalIdChange: (value: string) => void;
  personalIdLabel?: string;
}

/**
 * Reusable courier personal ID input component
 * Debouncing is handled at the query level
 */
export function CourierInput({
  personalId,
  onPersonalIdChange,
  personalIdLabel,
}: CourierInputProps) {
  const { t } = useTranslation();

  return (
    <Input
      value={personalId}
      placeholder={t('Events.Filter.Courier.PersonalId.Placeholder')}
      label={`${personalIdLabel ?? t('Events.Filter.Courier.PersonalId')}`}
      onChange={(ev) => onPersonalIdChange(ev.target.value)}
    />
  );
}
